(function Module() {
	'use strict';
	
	var mySynchModules = require('../config');
	var config = mySynchModules.config;
	mySynch.controller('EmmRetrieveShostListController', [
		'$scope',
        '$window',
		'ApiFactory',
		'MySynchFactory',
	    '$q',
		'ViewAuthorizationFactory',
        'mySynchEnumerationService',
        'clientLoggerService',
		function EmmRetrieveShostListController($s,$window, api, MSF,$q,viewAuth,mySynchEnumSvc, log) {

            $s.loading = false;
            $s.reportLoading = false;
            $s.refreshCheckInProgress = false;
            $s.submitting = false;
            $s.shotListDestUploadedDate = "";
          
            $s.hasUpdatePermission = false;
            $s.updatePermissionCode = 'EMM_RETRIEVE_SHOT_LIST_UPDATE';

            const envName = MSF.getEnvironmentName();
            //TODO: refactor this variable to get the array from codefile 
            $s.pageViewBetaReq = ["eMM"];

            
            // Upload API Url - defaulted to Stage here , but is set for the environment on load of the screen
            let eMMApiUrl = "https://mysynchemmservices-stage.azurewebsites.net/api/mysynch-upload-shotlist";

            $s.shotListExists = false; 
            $s.shotListUploadDate; 

            $s.dropzone;
            $s.rawCsvData = {headers: [], columnData:[]};
            $s.previewShotList = {headers: [], columnData:[]};

            $s.shotListConfig = {shotListName: "",
                                 penColumnMap: "",
                                 cowIdColumnMap: "",
                                 eIdColumnMap: "",
                                 drugColumnMap: "",
                                 drugMaps:[]
                                };
            
            $s.customFieldNameTmpl = {id: 0,name:""};
            $s.infoFieldNameTmpl = {name:""};                    
            $s.customFieldTmpl = {id: 0,customFieldNameId: 0, name: "",value:""};
            $s.infoValueFieldTmpl = {field: "",value:""};
            $s.defaultCustomFieldNames =  [ 
                {id:1, name: ""},
                {id:2,name: ""},
            ];
            $s.customFieldNames = _.cloneDeep($s.defaultCustomFieldNames);
            
            $s.customFields = [];

            
            $s.isAddingCustomFields = false;
            $s.customFieldsTemp = [];
            $s.numTempCustomFields = 5;

            $s.shotListNameListItemTmpl = {herdShotListId: 0,shotListName: ""};
            $s.defaultShotListNameListItem = {herdShotListId:0,shotListName:"Select a shot list"};
             $s.shotListNamesList = [$s.defaultShotListNameListItem]; 
             $s.selectedShotList = $s.defaultShotListNameListItem;


            $s.noPenOptionDisplayValue = "No Pen";
            $s.noPenOptionValue = -1;
            $s.allCowsOptionValue = "All Cows";                                

            $s.penColumnOptions = [$s.noPenOptionDisplayValue];
            $s.cowIdColumnOptions = [];
            $s.eIdColumnOptions = [];
            $s.drugColumnOptions = [$s.allCowsOptionValue];
            // TODO-1: Get these from CodeFile instead
            $s.treatmentDrugOptions = [{drugName:"GONAbreed",drugCode:"GO"},
                                       {drugName:"EstroPLAN",drugCode:"ES"},
                                       {drugName:"Vaccination", drugCode:"VC"},
                                       {drugName:"Other",    drugCode:"OT"}
                                      ];

            $s.drugMapItemTpl = {drugName: "",drugMap:""};
           
         

            $s.destinationShotList = [];
            $s.currentDropZoneError = ''; 
            $s.submitErrorText = "";

            $s.uploadShotListDataTmpl = {
                                        herdId: 0,
                                        overwriteShotList: false,
                                        shotListConfig: {},
                                        herdShotList:[],
                                        prevHerdShotList: []
                                    };
            $s.uploadShotListData = _.cloneDeep($s.uploadShotListDataTmpl);
            $s.currentActiveHerd = MSF.getActiveHerd();
            $s.currentActiveFarm = MSF.getActiveFarm();
            $s.territoryManager = MSF.getActiveFarmTerritoryManager(); 

            let herdId = _.get($s.currentActiveHerd,'herdId',_.get($s.currentActiveFarm,'herds[0].herdId'));

            $s.currentCsvFileName= "";
          


            const mobileWidthThreshold = 768;
             

            var deregOnHerdChange = undefined;
            
 
            
            $s.checkPermissions = function checkPermissions(callback){
                if(!viewAuth.farmIsInBeta($s.pageViewBetaReq)){
                    MSF.loadPage('Login');
                }

                callback();
            };
        
         $s.startStopSpinner = function startStopSpinner(){
             $s.loading = !$s.loading;
         };

         $s.toggleModal = function (modalId) {
            var modal = $('#' + modalId);
            if (!modal) return;

            if (modal.is(':visible')) {
                modal.css("display", "none");
            } else {
                modal.css("display", "block");
            }
        };
     
         // function that update the containers to the page layout after a file is chosen or browsed to
         $s.onFileChosen = function onFileChosen(){

            // reset some of the controller's state
            $s.resetControllerData();
               
            var rawShotListTbleData = _.cloneDeep($s.rawCsvData);

            rawShotListTbleData.headers = _.map(rawShotListTbleData.headers,function(currentHeader,currentHeaderIndex,array){
                                                    var arraySlice =  _.slice(array,0,currentHeaderIndex + 1);   
                                                    var numDupHeaders = _.filter(arraySlice,function(header){return header == currentHeader;});
                                                     if(numDupHeaders.length > 1){
                                                         return currentHeader+'..'+numDupHeaders.length;
                                                     }else{
                                                         return currentHeader;
                                                     }
                                          });

              
             $s.previewShotList = _.cloneDeep(rawShotListTbleData);

             _.set($s.shotListConfig,'shotListName',_.get($s.dropzone,'files[0].name'));
             $s.shotListSourceDate    = moment(_.get($s.dropzone,'files[0].lastModifiedDate')).format('MM/DD/YYYY, h:mm a');
             
             var currentPenColumnMap    = _.get($s.shotListConfig,"penColumnMap"    ,"");
             var currentCowIdColumnMap  = _.get($s.shotListConfig,"cowIdColumnMap"  ,"");
             var currentEIdColumnMap    = _.get($s.shotListConfig,"eIdColumnMap"    ,"");
             var currentDrugColumnMap   = _.get($s.shotListConfig,"drugColumnMap"   ,"");
             _.set($s.shotListConfig,'penColumnMap',    (_.isNull(currentPenColumnMap)   || _.isEmpty(currentPenColumnMap) || (!_.includes($s.previewShotList.headers,currentPenColumnMap)) && !_.isEqual(currentPenColumnMap,$s.noPenOptionDisplayValue))      ? "" : currentPenColumnMap);
             _.set($s.shotListConfig,'cowIdColumnMap',  (_.isNull(currentCowIdColumnMap) || _.isEmpty(currentCowIdColumnMap) || !_.includes($s.previewShotList.headers,currentCowIdColumnMap))  ? "" : currentCowIdColumnMap);
             _.set($s.shotListConfig,'eIdColumnMap',    (_.isNull(currentEIdColumnMap)   || _.isEmpty(currentEIdColumnMap) || !_.includes($s.previewShotList.headers,currentEIdColumnMap))      ? "" : currentEIdColumnMap);
             _.set($s.shotListConfig,'drugColumnMap',   (_.isNull(currentDrugColumnMap)  || _.isEmpty(currentDrugColumnMap) || (!_.includes($s.previewShotList.headers,currentDrugColumnMap) && !_.isEqual(currentDrugColumnMap,$s.allCowsOptionValue)))    ? "" : currentDrugColumnMap);

               

             $s.penColumnOptions    = _.union($s.penColumnOptions,_.cloneDeep(rawShotListTbleData.headers));
             $s.cowIdColumnOptions  = _.cloneDeep(rawShotListTbleData.headers);
             $s.eIdColumnOptions    = _.cloneDeep(rawShotListTbleData.headers);
             $s.drugColumnOptions   = _.union($s.drugColumnOptions,_.cloneDeep(rawShotListTbleData.headers));


             
           
            $s.buildDrugMappingTableData();  
            
        
            $s.buildDestinationShotListTableData();
       

             // adjust css classes of containers 
             $("#dropzone-top-container").removeClass("col-lg-12");
             $("#dropzone-top-container").addClass("col-lg-6");
             $(".after-file-chosen").removeClass("dis-none");

         };

         $s.onMappingChange = function onMappingChange(mapping){

            // clearing destination shot list table data
            $s.destinationShotList = [];

            // clear error class and hide error text
            $s.submitErrorText = "";

            var drugItemMappingTypeName = "";
            var drugItemMappingId = "";
            if(_.includes(mapping,'drugMapItem')){
                drugItemMappingTypeName = 'drugMapItem';
                drugItemMappingId = mapping.replace(drugItemMappingTypeName,'');
            }else{
                drugItemMappingTypeName = mapping;
            }
            
            switch (drugItemMappingTypeName) {
                case 'penColumnMap':
                case 'cowIdColumnMap':
                case 'eIdColumnMap':
                    if(_.isNull(_.get($s.shotListConfig,drugItemMappingTypeName))){
                        _.set($s.shotListConfig,drugItemMappingTypeName,"");
                    }      
                    break;
            
                case 'drugColumnMap':
                    if(_.isNull(_.get($s.shotListConfig,drugItemMappingTypeName))){
                        _.set($s.shotListConfig,drugItemMappingTypeName,"");
                        _.set($s.shotListConfig,"drugMaps",[]);
                    }
                    break;
                case 'drugMapItem':
                    if(_.isNull(_.get($s.shotListConfig,`drugMaps[${drugItemMappingId}].drugMap`))){
                        _.set($s.shotListConfig,`drugMaps[${drugItemMappingId}].drugMap`,"");
                    }
                     break;
            }
        
            // clear the sepcific input control's error border
            $(`#${mapping}`).removeClass("error-input-important");
           
            
            // only drop  the drug map table container's error border when all flagged drugs have been mapped. 
            if(_.isUndefined($("#drugMapTableContainer").find(".error-input-important")[0])){
                $("#drugMapTableContainer").removeClass("error-input-important");
            }
            
            var drugMappingColumn = _.get($s.shotListConfig,'drugColumnMap');
            if(!_.isEmpty(drugMappingColumn) && _.isEqual(mapping,'drugColumnMap')){
                $s.buildDrugMappingTableData();      
            } 

       
            $s.buildDestinationShotListTableData();
            
 

         };

         $s.onCloseModal = function onCloseModal(action){
             if(!_.isEqual(action,"cancel")){
                $s.uploadShotListData.overwriteShotList = _.isEqual(action,"overwrite") ? true : false;
                $s.buildUploadShotListData();
                $s.toggleModal("overwriteShotListModal");
                $s.dropzone.processQueue();
             }else{
                 $s.toggleModal("overwriteShotListModal");
             }
         };


         $s.onCustomFieldNameChange = function onCustomFieldNameChange(customFieldNameObj) {
            console.log("A Custom Filed Name Changed!");
            if($s.isAddingCustomFields){
                $s.onCancelAddCustomFieldValues();
            }

            if(_.uniq($s.customFieldNames).length > 1){
                var customFieldNameId = _.get(customFieldNameObj,'id');
                var newCustomFieldName = _.get(customFieldNameObj,'name');
               _.forEach($s.customFields,function(customField){
                     if(_.isEqual(_.get(customField,'customFieldNameId'),customFieldNameId)){
                         _.set(customField,'name',newCustomFieldName);
                     }
               });
            }

         };
         $s.onAddCustomFieldNameChange = function onAddCustomFieldNameChange(customField) {
            var customFieldNameChoice = _.get(customField,'name'); 
            var customFieldNameObj = _.find($s.customFieldNames,{name: customFieldNameChoice});
            if(!_.isUndefined(customFieldNameObj)){
                var customFieldNameId = _.get(customFieldNameObj,'id');
                _.set(customField,'customFieldNameId',customFieldNameId);
            }

         };
         $s.addCustomFieldValues = function addCustomFieldValues() {
              $s.isAddingCustomFields = true;

              $s.customFieldsTemp = _.map(_.range($s.numTempCustomFields),function(customField,index){
                                        return  _.set(_.cloneDeep($s.customFieldTmpl),'id',index);
                                    });
                                    
         };
       

         $s.onSaveCustomFieldValues = function onSaveCustomFieldValues() {
            $s.isAddingCustomFields = false;
       
            $s.customFields = _.union($s.customFields,_.reject(_.unique($s.customFieldsTemp,function(customField){return [customField.name, customField.value].join(); }),function(customField){ 
                                                                        var fieldName = _.get(customField,'name');
                                                                        var fieldValue = _.get(customField,'value');

                                                                        return  _.isEmpty(_.trim(fieldName))
                                                                            ||  _.isEmpty(_.trim(fieldValue))
                                                                            || !_.isUndefined(_.find($s.customFields,{name:fieldName,value:fieldValue}));   
                                                                        }));
            $s.customFields = _.sortByOrder($s.customFields,["customFieldNameId"],["asc"]);                                                                
            $s.customFieldsTemp = [];
         };
         $s.onCancelAddCustomFieldValues = function onCancelAddCustomFieldValues() {
            $s.isAddingCustomFields = false;
            $s.customFieldsTemp = [];
         };
         $s.onRemoveCustomFieldValue = function onRemoveCustomFieldValue(customField) {
             $s.customFields = _.reject($s.customFields,customField);
         };

         $s.onClearCustomFieldValues = function onClearCustomFieldValues() {
            $s.onCancelAddCustomFieldValues();
            $s.customFieldNames = _.cloneDeep($s.defaultCustomFieldNames);
            $s.customFields = [];
         };


         $s.onToggleLoadCustomFiledsFromShotList = function onToggleLoadCustomFiledsFromShotList(){
             api.getHerdShotListNames(herdId,function(error,herdShotLisNamesData){
                 if(!_.isUndefined(herdShotLisNamesData) && !_.isNull(herdShotLisNamesData)){
                    $s.shotListNamesList = _.union($s.shotListNamesList,_.cloneDeep(herdShotLisNamesData));
                 } 
                 $s.toggleModal("shotListNamesListModal"); 
             });
         };

         $s.onLoadCustomFiledsFromShotList = function onLoadCustomFiledsFromShotList(){
           var selectedHerdShotListId = _.get($s.selectedShotList,'herdShotListId');
           var selectedHerdShotListName = _.get($s.selectedShotList,'shotListName');
           if((!_.isUndefined(selectedHerdShotListId) && !_.isUndefined(selectedHerdShotListName)) && !_.isEqual(selectedHerdShotListId,0)){
              api.getHerdShotListCustomFields(herdId,selectedHerdShotListId,function(error,herdShotListCustomFieldsData){
                   if(!_.isUndefined(herdShotListCustomFieldsData) && !_.isNull(herdShotListCustomFieldsData) && !_.isEmpty(herdShotListCustomFieldsData)){
                       var loadedCustomFieldNames = []; 
                        try {  
                            loadedCustomFieldNames = JSON.parse(_.get(herdShotListCustomFieldsData[0],'customFieldNames',"[]"));
                        }catch(e){ console.log("failed to parse custom field names");}

                       var loadedCustomFields = [];
                       try{
                        loadedCustomFields  = JSON.parse(_.get(herdShotListCustomFieldsData[0],'customFields',"[]"));
                       }catch(e){ console.log("failed to parse custom fields");}

                         if(!_.isEmpty(loadedCustomFieldNames)){
                            $s.customFieldNames = _.map(_.uniq(loadedCustomFieldNames,'CustomFieldName'),function(loadedCustomFieldNameObj){
                                  var customFieldNameItem = _.cloneDeep($s.customFieldNameTmpl);
                                  _.set(customFieldNameItem,'id',_.get(loadedCustomFieldNameObj,'Id',0));
                                  _.set(customFieldNameItem,'name',_.get(loadedCustomFieldNameObj,'CustomFieldName',""));
                                  return customFieldNameItem;
                            });
                         }  
                         
                         if(!_.isEmpty(loadedCustomFields)){
                               
                           $s.customFields = _.map(_.uniq(loadedCustomFields, function(custField) { return [custField.CustomFieldName, custField.CustomFieldValue].join(); }),function(loadedCustomFieldObj){
                                    var customFieldItem = _.cloneDeep($s.customFieldTmpl);
                                    _.set(customFieldItem,'id',_.get(loadedCustomFieldObj,'Id',0));
                                    _.set(customFieldItem,'customFieldNameId',_.get(loadedCustomFieldObj,'CustomFieldNameId',0));
                                    _.set(customFieldItem,'name',_.get(loadedCustomFieldObj,'CustomFieldName',""));
                                    _.set(customFieldItem,'value',_.get(loadedCustomFieldObj,'CustomFieldValue',""));
                                    return customFieldItem;
                            });
                         
                         }

                        
                   }
              }); 
                
              }
           
              $s.shotListNamesList = [$s.defaultShotListNameListItem]; 
              $s.selectedShotList = $s.defaultShotListNameListItem;
            $s.toggleModal("shotListNamesListModal");            
         };
         $s.onCancelLoadCustomFiledsFromShotList = function onCancelLoadCustomFiledsFromShotList(){
            $s.shotListNamesList = [$s.defaultShotListNameListItem]; 
             $s.selectedShotList = $s.defaultShotListNameListItem;
            $s.toggleModal("shotListNamesListModal");     
        };

         $s.onUploadShotList = function onUploadShotList(){
           
            var errorObj = $s.validateUpload(); 

            if(errorObj.invalidErrorIds.length > 0){
                console.log("there were errors after submit");
                _.forEach(errorObj.invalidErrorIds,function(errorId){
                    $(errorId).addClass("error-input-important");
                });  
                $s.submitErrorText = errorObj.errorMsg;
            }else{
                console.log("shotlist was valid");
                if($s.shotListExists){
                    $s.toggleModal("overwriteShotListModal");
                }else{
                    $s.buildUploadShotListData();
                    $s.dropzone.processQueue();
                }
                
            }



         };

         $s.buildUploadShotListData = function buildUploadShotListData(){
            _.set($s.uploadShotListData,"herdId",_.get($s.currentActiveHerd,'herdId',_.get($s.currentActiveFarm,'herds[0].herdId')));
         
            var shotListConfig = _.cloneDeep($s.shotListConfig);
            _.forEach(_.get(shotListConfig,'drugMaps',[]),function(drugMapItem,index,array){
                array[index] = _.omit(drugMapItem,'$$hashKey');
            });
             _.set($s.uploadShotListData,'shotListConfig',shotListConfig);

             var destinationShotList = _.cloneDeep($s.destinationShotList);
             // if the no pen option is chosen , we update the Pen value for the shots to the no pen option
             if(_.isEqual(_.get($s.shotListConfig,'penColumnMap'),$s.noPenOptionDisplayValue)){
                _.forEach(destinationShotList,function(shot){
                     _.set(shot,'pen',$s.noPenOptionValue);
                });
             }
            
             _.forEach(destinationShotList,function(destShot,destIndex){
            
                // ensure that CowIds are numbers 
                   _.set(destShot,'cowId',Number(_.get(destShot,'cowId')));
                   
                // setting up pen and penStr   
                   var penIsNum = !_.isNaN(Number(_.get(destShot,'pen')));

                   if(penIsNum && !_.isEqual(Number(_.get(destShot,'pen')),-1)){
                    _.set(destShot,'penStr',_.get(destShot,'pen').toString());
                    _.set(destShot,'pen',Number(_.get(destShot,'pen')));
                    
                   }else{
                    _.set(destShot,'penStr',_.get(destShot,'pen').toString());
                    _.set(destShot,'pen',$s.noPenOptionValue);
                   }

                
                  // info and custom fields of shots 
            
                  var infoValues = [];
                 
                  var infoValueData = _.get($s.previewShotList,`columnData[${destIndex}]`,[]);
                   _.forEach(_.cloneDeep(infoValueData), function (infoValue,valueIndex) {
                    var infoFieldName = _.get($s.previewShotList,`headers[${valueIndex}]`,"");
                        var infoValuesItem = _.cloneDeep($s.infoValueFieldTmpl);
                        _.set(infoValuesItem,'field',infoFieldName);
                        _.set(infoValuesItem,'value',infoValue);
                        infoValues.push(infoValuesItem);
                   });
                  _.set(destShot,'infoValues',infoValues);
                  _.set(destShot,'custom',[]);
             });

             // info session data
             var infoFieldNames = [];
             var infoFieldNamesData = _.cloneDeep(_.get($s.previewShotList,'headers'),[]);
             _.forEach(infoFieldNamesData,function (infoFieldName) {
                 var infoFieldNamesItm = _.cloneDeep($s.infoFieldNameTmpl);
                 _.set(infoFieldNamesItm,'name',infoFieldName);
                 infoFieldNames.push(infoFieldNamesItm);
             });
             _.set($s.uploadShotListData,'infoFieldNames',infoFieldNames);

             $s.hasCustomFields = _.any($s.customFieldNames,function(customNameObj){ return !_.isEqual(_.trim(_.get(customNameObj,'name',"")),"");});
             // custom field data
             var customFieldNames = [];
             var customFields = [];
             if($s.hasCustomFields){

                customFieldNames = _.cloneDeep($s.customFieldNames);
                customFieldNames =   _.map(customFieldNames,function(customFieldNameObj) {
                                                return _.omit(customFieldNameObj,["id","$$hashKey"]);
                                            });

                customFields = _.cloneDeep($s.customFields);
                customFields = _.map(customFields,function (customFieldObj) {
                    return  _.omit(customFieldObj,["id","customFieldNameId","$$hashKey"]);
                });

             }


             _.set($s.uploadShotListData,'customFieldNames',customFieldNames);
             _.set($s.uploadShotListData,'customFields',customFields);
 
             
             _.set($s.uploadShotListData,'herdShotList',destinationShotList);
             var prevHerdShotListObj = $s.previewCsvDataToObject(_.cloneDeep($s.previewShotList));
             _.set($s.uploadShotListData,'prevHerdShotList',_.get(prevHerdShotListObj,'columnData',[])); 

         };

         $s.buildDrugMappingTableData = function buildDrugMappingTableData(){
             console.log("mapping drug map table data");
             
            var drugTreatmentColumn = _.get($s.shotListConfig,'drugColumnMap');

            if(_.isEqual(drugTreatmentColumn,$s.allCowsOptionValue)){
                   var drugListItem = _.cloneDeep($s.drugMapItemTpl);
                   _.set(drugListItem,'drugName','Treatment');
                   var prevDrugMap = _.get(_.find($s.shotListConfig.drugMaps,{drugName: "Treatment"}),'drugMap',"");
                   if(!_.isUndefined(prevDrugMap) && !_.isEmpty(prevDrugMap) && !_.isEmpty(_.get($s.shotListConfig,'drugColumnMap',""))){
                        _.set(drugListItem,'drugMap',prevDrugMap);
                    }

                    $s.shotListConfig.drugMaps = [drugListItem];

            }else{
                var previewShotListDataAsObject = $s.previewCsvDataToObject(_.cloneDeep($s.previewShotList));    
                $s.shotListConfig.drugMaps  =  _.map(_.uniq(_.compact(_.pluck(previewShotListDataAsObject.columnData,_.get($s.shotListConfig,'drugColumnMap')))),function(drugName){
                                            var drugListItem = _.cloneDeep($s.drugMapItemTpl);
                                            _.set(drugListItem,'drugName',drugName);
                                            var prevDrugMap = _.get(_.find($s.shotListConfig.drugMaps,{drugName: drugName}),'drugMap',"");
                                            if(!_.isUndefined(prevDrugMap) && !_.isEmpty(prevDrugMap) && !_.isEmpty(_.get($s.shotListConfig,'drugColumnMap',""))){
                                                _.set(drugListItem,'drugMap',prevDrugMap);
                                            }
                                            return drugListItem;
                                        });
            }
            
         };

         $s.buildDestinationShotListTableData = function buildDestinationShotListTableData(){
            var previewShotListDataAsObject = $s.previewCsvDataToObject(_.cloneDeep($s.previewShotList));
            
            var penColumn =  _.get($s.shotListConfig,'penColumnMap',"");
            var cowIdColumn =  _.get($s.shotListConfig,'cowIdColumnMap',"");
            var drugColumn =  _.get($s.shotListConfig,'drugColumnMap',"");
            var eIdColumn =  _.get($s.shotListConfig,'eIdColumnMap',"");
            
            var destColumnData = [];
             _.forEach(previewShotListDataAsObject.columnData,function(prevShotListRow){
                  var destShotListRow = {
                         pen: _.isEqual(penColumn,$s.noPenOptionDisplayValue) ? $s.noPenOptionDisplayValue : _.get(prevShotListRow,penColumn.replace(/\./g,''),""),
                         cowId: _.get(prevShotListRow,cowIdColumn.replace(/\./g,''),""),
                         eId: _.get(prevShotListRow,eIdColumn.replace(/\./g,''),""),
                         drug: _.isEqual(drugColumn,$s.allCowsOptionValue) ? _.get($s.shotListConfig.drugMaps,'[0].drugMap',"") : _.get(_.find($s.shotListConfig.drugMaps,{drugName: _.get(prevShotListRow,drugColumn.replace(/\./g,''),"")}),'drugMap',"")
                      };
                  destColumnData.push(destShotListRow);
             });

             $s.destinationShotList = destColumnData;

         };

         $s.validateCsvFile = function validateCsvFile(){
             var errorObj = {isValid: true,errorMsg: ""};

 
             // Checking to if the csv file has data , if there was no data , we show an error. 
             if($s.rawCsvData.headers.length == 0 || $s.rawCsvData.columnData.length == 0){
                errorObj.isValid = false;
                errorObj.errorMsg = "The csv file contained no or invalid data. Please try another .csv file.";
                return errorObj;
             }

             // A proper shotlist for MySynch needs to have at least 3 columns
             if($s.rawCsvData.headers.length < 3 ){
                errorObj.isValid = false;
                errorObj.errorMsg = "The csv file needs contain at least 3 columns. Please try another .csv file.";
                return errorObj;
             }

 
             return errorObj;
         };

         $s.validateUpload = function validateUpload(){
            var errorObj = {invalidErrorIds: [],errorMsg: ""};
           

            //-- all of the required columns have a value------

            if(_.isEmpty(_.trim($s.shotListConfig.shotListName)) || _.isUndefined(_.trim($s.shotListConfig.shotListName))){
                errorObj.invalidErrorIds.push("#shotListName");
            }

            if(_.isEmpty(_.trim($s.shotListConfig.penColumnMap)) || _.isUndefined(_.trim($s.shotListConfig.penColumnMap))){
                errorObj.invalidErrorIds.push("#penColumnMap");
            }
            if(_.isEmpty(_.trim($s.shotListConfig.cowIdColumnMap)) || _.isUndefined(_.trim($s.shotListConfig.cowIdColumnMap))){
                errorObj.invalidErrorIds.push("#cowIdColumnMap");
            }
            if(_.isEmpty(_.trim($s.shotListConfig.drugColumnMap)) || _.isUndefined(_.trim($s.shotListConfig.drugColumnMap))){
                errorObj.invalidErrorIds.push("#drugColumnMap");
            }

            if(_.isEmpty($s.shotListConfig.drugMaps)){
                errorObj.invalidErrorIds.push("#drugMapTableContainer");
            }

            var unMappedDrugItems = _.filter($s.shotListConfig.drugMaps,function(drugMapItem){return _.isEmpty(drugMapItem.drugMap);}); 
            if(unMappedDrugItems.length > 0){
                _.forEach(unMappedDrugItems,function(unMappedDrugItem){
                     errorObj.invalidErrorIds.push(`#${unMappedDrugItem.drugName}`);
                });
                errorObj.invalidErrorIds.push("#drugMapTableContainer");
            }  

            if(errorObj.invalidErrorIds.length > 0){
                _.set(errorObj,'errorMsg', "There are some required fields missing above.");
                return errorObj;
            }

            //-------------------------------------------------

            //-- data validations -----------------------------
            
             // Pen column needs to have number values
             var penColumnValues = _.pluck($s.destinationShotList,"pen");

             var foundEmptyValue = _.any(penColumnValues,function(penColVal){
                                        return (_.isEmpty(_.trim(penColVal)));
                                    });
             if(foundEmptyValue){
                errorObj.invalidErrorIds.push("#penColumnMap");
                  _.set(errorObj,'errorMsg', "The Pen column has values that are blank. Please, Update the CSV and re-upload again.");
             }

             

             // CowId column needs to have number values
             var cowIdColumnValues = _.pluck($s.destinationShotList,"cowId");

             var foundNonNumberValue = _.any(cowIdColumnValues,function(cowIdColVal){
                                            return (_.isNaN(Number(cowIdColVal)) && !_.isEmpty(_.trim(cowIdColVal))) || _.isEmpty(_.trim(cowIdColVal));
                                    });
             if(foundNonNumberValue){
                errorObj.invalidErrorIds.push("#cowIdColumnMap");
                  _.set(errorObj,'errorMsg', "The CowId column's data is not in the correct format.");
             }

             if(errorObj.invalidErrorIds.length > 0){
              
                return errorObj;
            }
            
            //-------------------------------------------------

            return errorObj;
         };

         $s.previewCsvDataToObject = function previewCsvDataToObject(csvData){

            var dataObjects = [];
            
            _.forEach(_.get(csvData,"columnData",[]),function(columnDataRow){
                var dataObject = {};
                 _.forEach(columnDataRow,function(csvDataPoint,csvDataPointIndex){
                      _.set(dataObject,_.get(csvData,`headers[${csvDataPointIndex}]`).replace(/\./g,''),csvDataPoint);
                 });
                 if(!_.isEmpty(dataObject)){
                     dataObjects.push(dataObject);
                 }
            });

            _.set(csvData,'columnData',dataObjects);

            return csvData;

         };

         $s.processCsvFile = function processCsvFile(file){

            var processCsvFilePromise = $q.defer();

             console.log("processing csv file");

             var fileName = _.get(file,'name');

             file.text().then(function(csv){

                // Newline split
                var lines = _.compact(_.map(csv.split("\r\n"),function(csvLine){
                                   if(   !_.includes(csvLine,"Total:") 
                                      && !_.includes(csvLine,"<page>")
                                      && !_.includes(csvLine,"in PEN")
                                      && !_.includes(csvLine,"i,n PEN")
                                      && !_.isEqual(_.trim(csvLine.replace(/,/g,'')),"")){
                                      return _.trim(csvLine);
                                   }              
                               }));
                var result = [];
              

                var uniqHeaders = [];
                var uniqHeaderIndexes = [];
                if(lines.length > 0){
                    _.forEach(_.compact(lines[0].split(",")),function(header,index){
                                    
                            if(!_.includes(uniqHeaders,header.replace(/"/g,''))){
                                uniqHeaders.push(_.trim(header.replace(/"/g,'')));
                                uniqHeaderIndexes.push(index);
                            }
                                                
                    });
                    
                    $s.rawCsvData.headers = uniqHeaders;
                    for (var i = 1; i < lines.length; i++) {
                        var valArray = [];
                        //Comma split
                        var currentline = _.pullAt(lines[i].split(","),uniqHeaderIndexes);
                        for (var j = 0; j < uniqHeaders.length; j++) {
                            valArray.push(_.trim(currentline[j]));
                        }
                        result.push(valArray);
                    }
                    $s.rawCsvData.columnData = result;
                    processCsvFilePromise.resolve({fileName:fileName}); 
                }else{
                    processCsvFilePromise.resolve({fileName:fileName}); 
                }
                
             });

             return processCsvFilePromise.promise;
         };


          $s.buildDropZone= function buildDropZone(){

            $s.reportLoading = true;
            $s.shotListDestUploadedDate = "";

            $s.dropzoneConfig = {
                url: eMMApiUrl,
                acceptedFiles: "text/csv",
                paramName: "shotListFile",
                autoProcessQueue: false,
                disablePreviews: true,
                clickable: ".dropzone,.dropzone-browse-button",
                addedfile: function(file) {
                    file.previewElement = $window.dropZoneModule.Dropzone.createElement(this.options.previewTemplate);
                    // Now attach this new element some where in your page

                    // only process one file at a time, but allow replacement of original file
                    if($s.dropzone.files.length > 1){
                        this.removeFile($s.dropzone.files[0]);
                    } 
                    
                    
                    $s.$applyAsync(function(){
                       // first clear previous error 
                      $s.currentDropZoneError = "";
                      $s.currentCsvFileName = "";
                    });

                  
                     console.log("file uploaded to dropzone");
                    if(_.isEqual(file.type,"text/csv")){
                        $s.processCsvFile(file).then(function(result){
                               var validationResult = $s.validateCsvFile();

                               if(!validationResult.isValid){
                                   $s.currentDropZoneError = validationResult.errorMsg;
                               }else{
                                   var csvFileName = _.get(result,'fileName');
                                    $s.currentCsvFileName = csvFileName;
                                   $s.onFileChosen();
                               }
                        });  
                    }
                    
 
                    
                },
                sending: function(file,xhr,formData){
                    $s.submitting = true;
                    var herdKey = _.get($s.currentActiveHerd,'herdKey',_.get($s.currentActiveFarm,'herds[0].herdKey'));
                   
                   var dt = moment();
                   var now = moment(dt).subtract(moment(dt).utcOffset(), 'minutes');
                   var shotListUploadDate = now.format('YYYY.MM.DD HH:mm:ss');

                   // rename shotlist file for later consumption in E-Med
                   _.set($s.uploadShotListData,'shotListConfig.shotListName',_.get($s.uploadShotListData,'shotListConfig.shotListName').replace(/\.csv/gi,'')+"_"+now.format("YYYYMMDDkkmm"));    

                   
                   formData.append("fileDate",shotListUploadDate); 
                   formData.append("herdKey",herdKey);
                   formData.append("uploadJsonData",JSON.stringify(_.cloneDeep($s.uploadShotListData)));
                },
                error: function(file,msgObj){
                    console.log("There was an error processing file with dropzone");
                    $s.submitting = false;
                    var msg = _.get(msgObj,'Message',""); 
                   if(_.includes(msg,"eMMServiceError:")){
                        MSF.notify.danger(msg);
                   }else{
                        this.removeFile(file);
                        $s.$applyAsync(function(){
                            if(!_.isUndefined(msg)){
                                $s.currentDropZoneError = msg;
                            }
                        });
                   }
                    

                },
                success: function(file){
                    $s.shotListExists = true;
                    $s.submitting = false;
                    MSF.notify.success('The shot list was uploaded successfully');
                    this.removeFile($s.dropzone.files[0]);
                    this.addFile(file);

                    $s.$applyAsync(function() {
                        var dt = moment();
                        $s.shotListDestUploadedDate = moment().format('MM/DD/YYYY, h:mm a');
                    } );
                }

            };
          
            $s.dropzone = new $window.dropZoneModule.Dropzone("div.dropzone",  $s.dropzoneConfig);
                
          };

          function clearDropzones() {
            $('.dropzone').each(function () {
        
                let dropzoneControl = $(this)[0].dropzone;
                if (dropzoneControl) {
                    dropzoneControl.destroy();
                }
            });
        }

         $s.resetControllerData = function resetControllerData(){
            $s.uploadShotListData = _.cloneDeep($s.uploadShotListDataTmpl);
            $s.destinationShotList = [];
            $s.submitErrorText = "";

            // clear highlighted errors
            $(".error-input-important").removeClass("error-input-important");

         }

          
		  $s.$on("$destroy", function() {
			
			log.info("dashboard destroy called");
	
		
			if(!_.isUndefined(deregOnHerdChange)) {deregOnHerdChange();}
	
		});

      
               
           $s.buildReportData = function buildReportData(reportData){
               _.set($s.shotListExists,_.get(reportData,'cntShotListsToday',0) > 0);

               _.set($s.shotListConfig,'shotListName',_.get(reportData,'dcNameOfList',""));
               _.set($s.shotListConfig,'penColumnMap',_.get(reportData,'column_Pen',""));
               _.set($s.shotListConfig,'cowIdColumnMap',_.get(reportData,'column_CowId',""));
               _.set($s.shotListConfig,'eIdColumnMap',_.get(reportData,'column_EID',""));
               _.set($s.shotListConfig,'drugColumnMap',_.get(reportData,'column_Drug',""));
               var configDrugMaps = [];
               try{
                    configDrugMaps = JSON.parse(_.get(reportData,'drugsListedJson',"[]"));
               }catch(e){
                   console.log("There was an error parsing the loading in drug maps.");
               }
               _.set($s.shotListConfig,'drugMaps',configDrugMaps);
                
           }; 

                 
           $s.loadReports = function loadReports(){
              
             api.getHerdShotListConfig(herdId,function(error,herdShotListConfigData){

                
                $s.buildReportData(_.get(herdShotListConfigData,'[0]'));
                
                
                clearDropzones();

                var dropZoneDiv = $(".dropzone").get(0);
                if(!_.isUndefined(dropZoneDiv)){
                    $s.buildDropZone();
                }else{
                    var deregDropZoneDivWatch = $s.$watch(dropZoneDiv,function(newValue,oldValue,scope){
                    
                        var dropZoneDiv = $(".dropzone").get(0);     
                    
                        if(!_.isUndefined(dropZoneDiv)){
                            $s.buildDropZone();
                            deregDropZoneDivWatch();
                        }
                    });
                }
             });
             
           };

           function setEMMApiUrl(){
               switch(envName){
                   case "PROD":
                       eMMApiUrl = "https://mysynchemmservices.azurewebsites.net/api/mysynch-upload-shotlist";
                       break;
                    case "STAGE":
                        eMMApiUrl = "https://mysynchemmservices-stage.azurewebsites.net/api/mysynch-upload-shotlist";
                        break;
                    case "TEST":
                        eMMApiUrl = "https://mysynchemmservices-test.azurewebsites.net/api/mysynch-upload-shotlist";
                        break;
                    case "DEV": 
                        eMMApiUrl = "https://mysynchemmservices-stage.azurewebsites.net/api/mysynch-upload-shotlist";
                        break;
                    default:
                        eMMApiUrl = "https://mysynchemmservices-stage.azurewebsites.net/api/mysynch-upload-shotlist";
                        break;
               }
           }


            MSF.ready(function onMsfReady() {

                $s.currentActiveHerd = MSF.getActiveHerd();
                $s.currentActiveFarm = MSF.getActiveFarm();

                $s.checkPermissions(function(){

                
                        if(_.isEqual(_.get($s.currentActiveFarm,'allowEMM'),true)) { 
                        herdId = _.get($s.currentActiveHerd,'herdId',_.get($s.currentActiveFarm,'herds[0].herdId'));
                        $s.hasUpdatePermission = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission',$s.updatePermissionCode));
                        setEMMApiUrl();
                        $s.loadReports();

                        
                        
                        }

                        deregOnHerdChange =   $s.$on('herd:changed', function(){

                            $s.loading = false;
                         
                                $s.currentActiveHerd = MSF.getActiveHerd();
                                $s.currentActiveFarm = MSF.getActiveFarm();
                            $s.checkPermissions(function(){
                                if(_.isEqual(_.get($s.currentActiveFarm,'allowEMM'),true)) { 
                                    $s.hasUpdatePermission = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission',$s.updatePermissionCode));
                                    herdId = _.get($s.currentActiveHerd,'herdId',_.get($s.currentActiveFarm,'herds[0].herdId'));
                                    setEMMApiUrl();
                                    $s.loadReports();
                                
                                    
                                }
                             });
                        });

                });


            });
            		 
		}
	]);
})();
